module.exports = __webpack_public_path__ + "static/media/duck.6afd97c9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/duck.jpeg
// module id = 116
// module chunks = 0